export default {
	create_new_contract: {
		en: "Create New Contract",
		ar: "عقد جديد",
	},
	renew_contract: {
		en: "Renew Contract",
		ar: "تجديد العقد",
	},
	terminate_contract: {
		en: "Terminate Contract",
		ar: "إنهاء عقد الإيجار",
	},
	edit: {
		en: "Edit",
		ar: "تحرير",
	},
	unitNo: {
		en: "Unit #",
		ar: "رقم الوحدة",
	},
	dmNo: {
		en: "DM #",
		ar: "رقم البلدية",
	},
	dewaNo: {
		en: "DEWA #",
		ar: "رقم ديوا",
	},
	unitType: {
		en: "Unit Type",
		ar: "نوع الشقة",
	},
	subType: {
		en: "Sub-Type",
		ar: "النوع الفرعي",
	},
	villa_name: {
		en: "Villa Name",
		ar: "اسم فيلا",
	},
	management_contract: {
		en: "Management Contract",
		ar: "عقد إدارة",
	},
	management_company_detail: {
		en: "Management Company Detail",
		ar: "تفاصيل شركة الإدارة ",
	},
	contract_details: {
		en: "Contract Details",
		ar: "تفاصيل العقد",
	},
	contract_no: {
		en: "Contract #",
		ar: "رقم العقد",
	},
	start_date: {
		en: "Start Date",
		ar: "تاريخ البدء",
	},
	end_date: {
		en: "End Date",
		ar: "تاريخ الانتهاء",
	},
	tenant_name_ar: {
		en: "Tenant Name (Ar)",
		ar: "اسم المستأجر (عربي)",
	},
	tenant_name_en: {
		en: "Tenant Name (En)",
		ar: "اسم المستأجر (الإنجليزية)",
	},
	tenant_name_en_new: {
		en: "Tenant Name (En)",
		ar: "اسم المستأجر (الإنجليزية)",
	},
	rental_amount: {
		en: "Rental Amount",
		ar: "قيمة الإيجار",
	},
	status: {
		en: "Status",
		ar: "الحالة",
	},
	tenant_information: {
		en: "Tenant Information",
		ar: "معلومات المستأجر",
	},
	contract_information: {
		en: "Contract Information",
		ar: "معلومات العقد",
	},
	payment_information: {
		en: "Payment Information",
		ar: "معلومات الدفع",
	},
	terms_and_conditions: {
		en: "Terms and Conditions",
		ar: "الشروط والأحكام",
	},
	ejari_fee_payment: {
		en: "Ejari Fee Payment",
		ar: "دفع رسوم إيجاري",
	},
	tenant_search: {
		en: "Tenant search",
		ar: "البحث عن المستأجر",
	},
	tenant_type: {
		en: "Tenant Type",
		ar: "نوع المستأجر",
	},
	identification_type: {
		en: "Identification Type",
		ar: "طريقة التعريف",
	},
	lic_issuer_emirate: {
		en: "License Issuer Emirate",
		ar: "اختر ترخيص المصدر إمارة",
	},
	lic_issuer_authority: {
		en: "License Issuer Authority",
		ar: "هيئة المصدر رخصة",
	},
	lic_issue_date: {
		en: "License Issue Date",
		ar: "تاريخ إصدار الرخصة",
	},
	lic_exp_date: {
		en: "License Expiry Date",
		ar: "تاريخ انتهاء الرخصة",
	},
	lic_number: {
		en: "License Number",
		ar: "رقم الرخصة التجارية",
	},
	company_name_en: {
		en: "Company Name English",
		ar: "اسم الشركة بالإنجليزية",
	},
	company_name_ar: {
		en: "Company Name Arabic",
		ar: "اسم الشركة بالعربية",
	},
	license_state: {
		en: "License State",
		ar: "تاريخ الرخصة",
	},
	gender: {
		en: "Gender",
		ar: "الجنس",
	},
	date_of_birth: {
		en: "Date of Birth",
		ar: "تاريخ الميلاد",
	},
	po_box: {
		en: "P.O Box",
		ar: "صندوق البريد",
	},
	no_of_co_occupants: {
		en: "Number of co-occupants",
		ar: "عدد القانطين",
	},
	passport_information: {
		en: "Passport Information",
		ar: "معلومات جوازالسفر",
	},
	passport_number: {
		en: "Passport Number",
		ar: "رقم جواز السفر",
	},
	country: {
		en: "Country",
		ar: "البلد",
	},
	passport_issue_place: {
		en: "Passport Issue Place",
		ar: "بلد إصدار جواز السفر",
	},
	passport_issue_place_en: {
		en: "Passport Issue Place",
		ar: "بلد إصدار جواز السفر",
	},
	passport_issue_place_ar: {
		en: "Passport Issue Place (AR)",
		ar: "بلد إصدار جواز السفر بالعربية",
	},
	passport_issue_date: {
		en: "Passport Issue Date",
		ar: "تاريخ إصدار جواز السفر",
	},
	passport_exp_date: {
		en: "Passport Expiry Date",
		ar: "تاريخ إنتهاء جواز السفر",
	},
	residence_information: {
		en: "Residence Information",
		ar: "بيانات المقيم",
	},
	authority_residence_information: {
		en: "Contact Person Residence Information",
		ar: "العنوان",
	},
	residence_visa_number: {
		en: "Residence Visa Number",
		ar: "رقم الإقامة",
	},
	visa_start_date: {
		en: "Visa Start Date",
		ar: "تاريخ إصدار الإقامة",
	},
	visa_expiry_date: {
		en: "Visa Expiry Date",
		ar: "تاريخ انتهاء التأشيرة",
	},
	passport: {
		en: "Passport",
		ar: "جواز السفر",
	},
	license_information: {
		en: "License Information",
		ar: "بيانات الرخصة",
	},
	contact_information: {
		en: "Contact Information",
		ar: "بيانات التواصل",
	},
	proceed_to_contract_information: {
		en: "Proceed To Contract Information",
		ar: "الاستمرار إلى بيانات العقد",
	},
	select: {
		en: "Select",
		ar: "اختر",
	},
	company_information: {
		en: "Company Information",
		ar: "بيانات الشركة",
	},
	contact_name: {
		en: "Contact Person Name",
		ar: "اسم جهة الاتصال",
	},
	company_name: {
		en: "Company Name",
		ar: "اسم الشركة",
	},
	contract_start_date: {
		en: "Contract Start Date",
		ar: "تاريخ بداية العقد",
	},
	contract_end_date: {
		en: "Contract End Date",
		ar: "تاريخ انتهاء العقد",
	},
	grace_start_date: {
		en: "Grace Start Date",
		ar: "تاريخ بداية فترة السماح",
	},
	grace_end_date: {
		en: "Grace End Date",
		ar: "تاريخ انتهاء فترة السماح",
	},
	grace_period: {
		en: "Grace Period",
		ar: "فترة سماح العقد",
	},
	contract_grace_period: {
		en: "Contract Grace Period",
		ar: "فترة سماح العقد",
	},
	entire_period: {
		en: "Entire Period",
		ar: "كامل الفترة",
	},
	year: {
		en: "Year",
		ar: "السنة",
	},
	contract_value: {
		en: "Contract Value",
		ar: "قيمة العقد",
	},
	value: {
		en: "Value",
		ar: "القيمة",
	},
	discount_type: {
		en: "Discount type",
		ar: "نوع الخصم",
	},
	discount_value: {
		en: "Discount Value",
		ar: "قيمة الخصم",
	},
	none: {
		en: "None",
		ar: "لايوجد نتائج",
	},
	without_discount: {
		en: "Without Discount",
		ar: "بدون خصم",
	},
	fixed_value: {
		en: "Fixed Value",
		ar: "القيمة الثابتة",
	},
	percentage: {
		en: "Percentage",
		ar: "نسبة",
	},
	invalid_email: {
		en: "Invalid email address",
		ar: "البريد الإلكتروني غير صحيح",
	},
	invalid_mobile: {
		en: "Invalid mobile number",
		ar: "رقم الهاتف الجوال غير صحيح",
	},
	invalid_eid: {
		en: "Invalid Emirates ID",
		ar: "رقم الهوية غير صحيح",
	},
	from_date: {
		en: "From Date",
		ar: "من تاريخ",
	},
	to_date: {
		en: "To Date",
		ar: "إلى تاريخ",
	},
	calculate_total: {
		en: "Calculate total",
		ar: "حساب المجموع",
	},
	actual_value: {
		en: "Actual Value",
		ar: "القيمة الفعلية",
	},
	annual_rent: {
		en: "Annual Rent",
		ar: "الإيجار السنوي",
	},
	actual_annual_rent: {
		en: "Actual Annual Rent",
		ar: "الإيجار السنوي الفعلي",
	},
	actual_contract_value: {
		en: "Actual Contract Value",
		ar: "قيمة العقد الفعلية",
	},
	contract_amount: {
		en: "Contract Amount",
		ar: "قيمة العقد",
	},
	security_deposit: {
		en: "Security Deposit",
		ar: "مبلغ التأمين",
	},
	registration_reason: {
		en: "Registration Reason",
		ar: "سبب التسجيل",
	},
	cash: {
		en: "Cash",
		ar: "نقدا",
	},
	cheque: {
		en: "Cheque",
		ar: "شيك",
	},
	amount: {
		en: "Amount",
		ar: "المبلغ",
	},
	nb_payments: {
		en: "No. Of Payments",
		ar: "عدد الدفعات",
	},
	chq_nb: {
		en: "Cheque #",
		ar: "رقم الشيك",
	},
	chq_bank_name: {
		en: "Bank name",
		ar: "اسم البنك",
	},
	due_date: {
		en: "Due date",
		ar: "تاريخ الاستحقاق",
	},
	delete_payment_confirm: {
		en: "Are you sure you want to delete this payment?",
		ar: "هل أنت متأكد من حذف هذه الدفعة ؟",
	},
	add: {
		en: "Add",
		ar: "إضافة",
	},
	cash_payment: {
		en: "Cash Payment",
		ar: " الدفع نقدا",
	},
	payment_nb_not_valid: {
		en: "Payment plan count is not equal to number of payments",
		ar: "عدد الدفعات المدخلة يجب أن يساوى عدد الدفعات الكلي",
	},
	add_payment: {
		en: "Add Payment",
		ar: "إضافة دفعة",
	},
	payment_value_not_valid: {
		en: "Payment plan value is not equal to Rent Amount",
		ar: "مجموع قيمة الدفعات في خطة السداد لا تساوي قيمة الإيجار",
	},
	tenant_approval: {
		en: "Do you want to send notification to tenant for electronic approval?",
		ar: "هل تريد ارسال إخطار للمستاجر للموافقة",
	},
	submit: {
		en: "Submit",
		ar: "إرسال",
	},
	contract_added_successfully: {
		en: "Your contract request has been submitted successfully",
		ar: "تم تقديم طلبك بنجاح، رقم العقد الخاص بك هو",
	},
	activate_by_paying_ejari_fee: {
		en: "Please pay the fees to activate your contract",
		ar: "الرجاء دفع الرسوم لتفعيل العقد",
	},
	contract_number: {
		en: "Contract Number",
		ar: "رقم العقد",
	},
	fee_details: {
		en: "Fee Details",
		ar: "تفاصيل الرسوم",
	},
	pay_now: {
		en: "Pay Now",
		ar: "إدفع الآن",
	},
	payment_failed: {
		en: "Payment Failed",
		ar: "فشلت عملية الدفع",
	},
	successful_exclamation: {
		en: "Action Successfully Completed !",
		ar: "تمت العملية بنجاح",
	},
	inactive_contract: {
		en: "Your contract has been created and it is Inactive.\nPlease complete payment to activate the contract.\n Please share link for payment",
		ar: "تم إنشاء العقد الخاص بك وهو غير فعال الرجاء استكمال عملية دفع الرسوم لتفعيل العقد",
	},
	copy: {
		en: "Copy",
		ar: "نسخ",
	},
	contract_activated: {
		en: "Your contract has been created and is Active",
		ar: "تم  إنشاء و تفعيل العقد",
	},
	download_contract: {
		en: "Download contract",
		ar: "تنزيل عقد الإيجار",
	},
	tenant_contract_reg: {
		en: "Contract Approval request has been sent to Tenant.",
		ar: "تم إرسال طلب إعتماد عقد الإيجار إلى المستأجر.",
	},
	no_transaction: {
		en: "No Transactions",
		ar: "لا توجد معاملات",
	},
	edit_property_details: {
		en: "Edit Property Details",
		ar: "تعديل تفاصيل العقار",
	},
	unit_usage: {
		en: "Unit Usage",
		ar: "استخدام الشقة",
	},
	sub_type: {
		en: "Sub Type",
		ar: "النوع الفرعي",
	},
	termination_date: {
		en: "Termination Date",
		ar: "تاريخ إنهاء العقد",
	},
	termination_reason: {
		en: "Termination Reason",
		ar: "أسباب إنهاء العقد",
	},
	termination_date_between_start_end: {
		en: "Termination date should be between start and end date",
		ar: "تاريخ إنهاء العقد يجب أن يكون ضمن فترة العقد",
	},
	terminate_req_send: {
		en: "Your request for termination has been submitted successfully",
		ar: "تم تقديم طلب إنهاء العقد بنجاح",
	},
	is_common: {
		en: "Is Common",
		ar: "رقم ديوا المشترك",
	},
	dewa_premise: {
		en: "DEWA (Premise No.)",
		ar: "رقم العقار (ديوا)",
	},
	grace_date_validation: {
		en: "Grace Period should be either from a Contract Start Date or end of the Contract",
		ar: "يجب أن تكون فترة السماح إما من تاريخ بدء العقد أو نهاية العقد",
	},
	property_update_success: {
		en: "Property updated successfully.",
		ar: "تم تحديث بيانات العقار",
	},
	dewa_account_count: {
		en: "Please add at least one DEWA (Premise No.)",
		ar: "يرجى إضافة رقم ديوا واحد على الأقل (رقم العقار)",
	},
	ejari_data_incomplete: {
		en: "Property information is incomplete in Ejari systems. Please contact ejari support",
		ar: "معلومات العقار غير مكتملة في إيجاري، الرجاء الإتصال بأحد موظفي الدعم الفني",
	},
	certificate_contract_renew_error: {
		en: "This Contract cannot be Renewed. Please terminate this and register a new Contract.",
		ar: "لا يمكن تجديد هذا العقد. الرجاء إنهاء العقد ثم تسجيل عقد جديد.",
	},
	renewal_blocked_initial_approval: {
		en: "You cannot renew Ejari having Initial Approval Number.",
		ar: "لا يمكن تجديد إيجاري برقم الموافقة المبدئية",
	},
	contract_termination_success: {
		en: "Contract has been terminated successfully",
		ar: "تم تقديم طلب إنهاء العقد بنجاح",
	},
	residential: {
		en: "Residential",
		ar: "سكني",
	},
	commercial: {
		en: "Commercial",
		ar: "تجاري",
	},
	industrial: {
		en: "Industrial",
		ar: "صناعي",
	},
	staff_accomodation: {
		en: "Staff Accom.",
		ar: "سكن عمال",
	},
	calculate_rental_index: {
		en: "Calculate Rental Index",
		ar: "حساب مؤشر الإيجار",
	},
	main_area: {
		en: "Main Area",
		ar: "المنطقة الرئيسية",
	},
	area: {
		en: "Area",
		ar: "المنطقة",
	},
	current_annual_rent: {
		en: "Current Annual Rent",
		ar: "قيمة الإيجار الحالية",
	},
	bedrooms: {
		en: "Bedrooms",
		ar: "عدد الغرف",
	},
	category: {
		en: "Category",
		ar: "التصنيف",
	},
	sub_category: {
		en: "Sub Category",
		ar: "التصنيف الفرعي",
	},
	area_sq_ft: {
		en: "Area (Sq. Ft.)",
		ar: "المساحة (قدم مربع)",
	},
	no_of_rooms: {
		en: "Number Of Rooms",
		ar: "عدد الغرف",
	},
	rental_index: {
		en: "Rental Index",
		ar: "مؤشر الإيجار",
	},
	no_rental_index: {
		en: "Rental Index is not available",
		ar: "حاسبة الزيادة الإيجارية",
	},
	eid_expire_date: {
		en: "Emirates ID Expiry Date",
		ar: "تاريخ انتهاء بطاقة هوية الإمارات",
	},
	sub_leased: {
		en: "Sub Leased",
		ar: "مؤجرة من الباطن",
	},
	leased: {
		en: "Leased",
		ar: "مؤجرة",
	},
	sub_leases: {
		en: "Sub Leases",
		ar: "عقد الباطن",
	},
	all: {
		en: "All",
		ar: "الجميع",
	},
	leases: {
		en: "Leases",
		ar: "العقود",
	},
	sub_leased_value: {
		en: "Sub Leased Value",
		ar: "قيمة الإيجار",
	},
	size: {
		en: "Size",
		ar: "المساحة",
	},
	calculate_value: {
		en: "Calculate Value",
		ar: "احسب القيمة",
	},
	add_terms_conditions: {
		en: "Add Terms & Conditions",
		ar: "إضافة الشروط والأحكام",
	},
	cheque_payment: {
		en: "Cheque Payment",
		ar: "الدفع بشيك بنكي",
	},
	new_tenant: {
		en: "New Tenant",
		ar: "المستأجر الجديد",
	},
	tenant_new_desc: {
		en: "This tenant is not available. If you want to make a new tenant please click on New Tenant.",
		ar: "هذا المستأجر غير متوفر. إذا كنت ترغب في إضافة مستأجر جديد ، يرجى النقر على مستأجر جديد.",
	},
	terminate: {
		en: "Terminate",
		ar: "إنهاء العقد",
	},
	renew: {
		en: "Renew",
		ar: "تجديد العقد",
	},
	land_usage: {
		en: "Land Usage",
		ar: "استخدام الأرض",
	},
	shopping_mall: {
		en: "Mall Center",
		ar: "مركز التسوق",
	},
	unit_type: {
		en: "Unit Type",
		ar: "نوع الوحدة",
	},
	rental_index_not_found: {
		en: "Rental Index data are not available for this Area.",
		ar: "بيانات مؤشر الإيجار غير متوفرة لهذه المنطقة.",
	},
	terminated: {
		en: "Terminated",
		ar: "إنهاء",
	},
	payment_pending: {
		en: "Payment Pending",
		ar: "انتظار الدفع",
	},
	modification_request: {
		en: "Modification is Requested",
		ar: "تم طلب التعديل",
	},
	remarks: {
		en: "Remarks",
		ar: "الملاحظات",
	},
	search_by: {
		en: "Search by",
		ar: "البحث عن طريق",
	},
	property_search: {
		en: "Search Property",
		ar: "بحث عقار",
	},
	vacant: {
		en: "Vacant",
		ar: "شاغر",
	},
	my_tenant_request: {
		en: "My Requests",
		ar: "طلباتي",
	},
	comments: {
		en: "Comments",
		ar: "ملاحظات",
	},
	commercial_details: {
		en: "Commercial Details",
		ar: "تجاري - تفصيل",
	},
	document_details: {
		en: "Document Details",
		ar: "تفاصيل المستند",
	},
	req_modification: {
		en: "Request for Update",
		ar: "طلب تحديث",
	},
	property_selection: {
		en: "Property Selection",
		ar: "الرجاء اختيار العقار",
	},
	add_remarks: {
		en: "Add remarks",
		ar: "أضف الملاحظات",
	},
	re_submit: {
		en: "Resubmit",
		ar: "إعادة تقديم الطلب",
	},
	previous_tenant: {
		en: "Previous",
		ar: "السابق",
	},
	no_property: {
		en: "No property found",
		ar: "لم يتم العثور على العقار",
	},
	no_request_found: {
		en: "No request found",
		ar: "لا يوجد طلب",
	},
	register_tenant_error: {
		en: "You are not registered as a tenant. Please register to continue",
		ar: "أنت غير مسجل كمستأجر. يرجى التسجيل للمتابعة.",
	},
	register_tenant_success: {
		en: "Tenant registration is completed successfully!",
		ar: "تم تسجيل المستأجر بنجاح!",
	},
	document_name: {
		en: "Document name",
		ar: "اسم الملف",
	},
	ejari_requests: {
		en: "Ejari Requests",
		ar: "طلبات إيجاري",
	},
	requests_from_tenant: {
		en: "Requests from Tenant",
		ar: "طلبات من المستأجر",
	},
	land_sub: {
		en: "Land Sub No.",
		ar: "رقم الأرض الفرعي",
	},
	i_agree_to_the: {
		en: "I agree to the",
		ar: "أنا موافق",
	},
	register_certificate: {
		en: "Register Ejari Contract",
		ar: "تسجيل عقد إيجاري",
	},
	commercial_information: {
		en: "Commercial Information",
		ar: "المعلومات التجارية",
	},
	municipality_sub_no: {
		en: "Municipality Sub No.",
		ar: "رقم البلدية الفرعي",
	},
	no_tenant_request: {
		en: "No tenant request found",
		ar: "لم يتم العثور على طلب المستأجر",
	},
	invalid_property_id: {
		en: "Invalid Property ID",
		ar: "رقم العقار غير صحيح",
	},
	alert_cancel: {
		en: "Are you sure you want to cancel this request?",
		ar: "هل أنت متأكد من أنك تريد إلغاء هذا الطلب؟",
	},
	reject_request: {
		en: "Are you sure you want to reject this request?",
		ar: "هل أنت متأكد من أنك تريد رفض هذا الطلب؟",
	},
	document_required: {
		en: "Please add required documents to continue",
		ar: "الرجاء إضافة الوثائق المطلوبة للمتابعة",
	},
	tenant_details: {
		en: "Tenant Details",
		ar: "تفاصيل المستأجر",
	},
	tenant_name: {
		en: "Tenant Name",
		ar: "اسم المستأجر",
	},
	contract_success: {
		en: "Your contract registration is completed. You can track the status in ",
		ar: "اكتمال تسجيل العقد الخاص بك. يمكنك تتبع الحالة في",
	},
	send_to_tenant: {
		en: "Send To Tenant for payment",
		ar: "إرسال إلى المستأجر للدفع",
	},
	who_managing_error: {
		en: "This property is managed by owner.",
		ar: "العقار مدار من قبل المالك",
	},
	management_company: {
		en: "Management Company",
		ar: "شركة الإدارة",
	},
	management_company_login: {
		en: "Management Company Login",
		ar: "تسجيل دخول الشركة",
	},
	add_mobile_info: {
		en: "We couldn't find an associated mobile number with your username",
		ar: "لم نتمكن من العثور على رقم جوال مرتبط باسم المستخدم الخاص بك",
	},
	properties: {
		en: "Properties",
		ar: "العقارات",
	},
	other_properties: {
		en: "Other Properties",
		ar: "العقارات الأخرى",
	},
	dm_subNo: {
		en: "DM Sub No.",
		ar: "رقم البلدية الفرعي",
	},
	rental_amount_from: {
		en: "Rental Amount From",
		ar: "مبلغ الإيجار من",
	},
	rental_amount_to: {
		en: "Rental Amount To",
		ar: "مبلغ الإيجار إلى",
	},
	understand_contract: {
		en: "Understand Your Contract",
		ar: "افهم العقد الخاص بك",
	},
	ejari_req_docs: {
		en: "Required Documents",
		ar: "الوثائق المطلوبة",
	},
	ejari_req_docs_info: {
		en: "Following are the required documents for registering a Tenancy Contract",
		ar: "فيما يلي الوثائق المطلوبة لتسجيل عقد الإيجار",
	},
	ejari_registration_fees: {
		en: "Registration Fees",
		ar: "رسوم التسجيل",
	},
	who_is_managing: {
		en: "Who is Managing?",
		ar: "من يدير؟",
	},
	type: {
		en: "Type",
		ar: "النوع",
	},
	owner_name_management: {
		en: "Owner Name",
		ar: "اسم المالك",
	},
	contract_type: {
		en: "Contract Type",
		ar: "نوع العقد",
	},
	management_fee_text: {
		en: "Ejari fees will be deducted automatically from your Noqodi wallet, then the contract will be auto-activated.",
		ar: "سيتم خصم رسوم إيجاري تلقائيًا من محفظة نقودي الخاصة بك ، ثم يتم تفعيل العقد تلقائيًا.",
	},
	terms_template: {
		en: "Terms & Conditions Template",
		ar: "نموذج الشروط والأحكام",
	},
	templates: {
		en: "Templates",
		ar: "النماذج",
	},
	templates_info: {
		en: "You can select only one template at a time.",
		ar: "يمكنك اختيار نموذج واحد فقط في نفس الوقت.",
	},
	management_contract_inactive: {
		en: "Your contract has been created and it is in pending state.",
		ar: "تم إنشاء العقد الخاص بك وهو في حالة الانتظار.",
	},
	ejari_owner_login: {
		en: "Ejari Owner Login",
		ar: "تسجيل دخول إيجاري مالك",
	},
	user_not_support: {
		en: "User not supported",
		ar: "المستخدم غير معتمد",
	},
	enter_details_manually: {
		en: "Enter Details Manually",
		ar: " أدخل التفاصيل يدويًا",
	},
	locate_on_map: {
		en: "Locate on Map",
		ar: "تحديد الموقع على الخريطة",
	},
	display_result: {
		en: "Display Result",
		ar: "عرض النتيجة",
	},
	profile_found: {
		en: "Profile already exists!",
		ar: "الملف الشخصي موجود بالفعل!",
	},
	sub_area: {
		en: "Sub Area",
		ar: "المنطقة الفرعية",
	},
	submit_owner_pending: {
		en: "Request has been submitted to owner. Please contact your owner for approval. Track your request from My Request - Ejari Request.",
		ar: "تم تقديم الطلب إلى المالك. يرجى الاتصال بالمالك للحصول على الموافقة. تتبع طلبك من قسم طلباتي - طلبات ايجاري.",
	},
	terminate_submitted: {
		en: "Your Termination request has been submitted.  Please contact your owner for approval. Track your request from My Request - Ejari Request.",
		ar: "لقد تم إرسال طلب الإنهاء الخاص بك. تتبع طلبك من قسم طلباتي - طلبات ايجاري.",
	},
	active: {
		en: "Active",
		ar: "فعال",
	},
	pending_owner: {
		en: "Pending with owner",
		ar: "لا زال قيد العمل مع المالك",
	},
	date_and_time: {
		en: "Date and Time",
		ar: "التاريخ و الوقت",
	},
	my_tenancy_requests: {
		en: "My Tenancy Requests",
		ar: "طلبات عقدي",
	},
	unified_number: {
		en: "Unified Number",
		ar: "الرقم الموحد",
	},
	tenant_verify_error: {
		en: "You are not registered as a tenant.",
		ar: "أنت غير مسجل كمستأجر.",
	},
	an_error_occurred: {
		en: "An error occurred",
		ar: "حدث خطأ بالنظام",
	},
	lease_details: {
		en: "Lease Details",
		ar: "تفاصيل الايجار",
	},
	edit_request: {
		en: "Edit Request",
		ar: "تعديل الطلب",
	},
	english: {
		en: "English",
		ar: "English",
	},
	arabic: {
		en: "عربي",
		ar: "عربي",
	},
	calculated_value: {
		en: "Calculated Value",
		ar: "القيمة المحسوبة"
	},
	cancel_request: {
		en: "Cancel Request",
		ar: "إلغاء الطلب",
	},
	file_size_exceed: {
		en: "Selected file exceeds the maximum allowed size of ~MB",
		ar: "يتجاوز حجم الملف المحدد الحد الأقصى المسموح به وهو ~ ميغابايت"
	},
	upload_documents_note: {
		en: "Note: Maximum file size allowed is ~MB. Allowed files type are .jpg, .png and .pdf",
		ar: "ملاحظة: أقصى حجم مسموح به للملف هو ~ ميجابايت. نوع الملفات المسموح بها هي .jpg و .png و .pdf"
	},
	wrong_file_type: {
		en: "Allowed files type are .jpg, .png and .pdf",
		ar: " نوع الملفات المسموح بها هي .jpg و .png و .pdf"
	},
	identity_type: {
		en: "Identity Type",
		ar: "نوع الهوية",
	},
	hazardous_material_classification: {
		en: "Hazardous Material Classification",
		ar: "تصنيف المواد الخطرة",
	},
	manage_pets: {
		en: "Manage Pets",
		ar: "إدارة الحيوانات الأليفة",
	},
	pet_type: {
		en: "Pets Name",
		ar: "اسم الحيوان الأليف",
	},
	pet_count: {
		en: "Pets Count",
		ar: "عدد الحيوانات الأليفة",
	},
	pets: {
		en: "Pets",
		ar: "الحيوانات الأليفة",
	},
	add_pets: {
		en: "Add Pets",
		ar: "الحيوانات الأليفة",
	},
	add_pets_info: {
		en: "Enter the details of all the pets (dogs, cats and birds) which you possess",
		ar: "أدخل تفاصيل وبيانات جميع الحيوانات الأليفة التي تملكها (الكلاب، القطط، الطيور)",
	},
	pets_info_updated: {
		en: "Pets Information has been updated",
		ar: "تمّ تحديث بيانات الحيوانات الأليفة",
	},
	co_occupant_is_people_of_determination: {
		en: "Special Needs",
		ar: "أصحاب الهمم",
	},
	co_occupant_add_is_people_of_determination: {
		en: "Is the above person with special needs ?",
		ar: "هل الشخص المذكور أعلاه من أصحاب الهمم ؟",
	},
	add_more_pets: {
		en: "Add More Pets",
		ar: "إضافة حيوانات أليفة أخرى",
	},
	move_out_information: {
		en: "Previous Contract Move Out Information",
		ar: "العقد السابق مع معلومات خدمة إيقاف الكهرباء و المياه",
	},
	move_in_date: {
		en: "Current Contract Move-In Date",
		ar: "تاريخ تفعيل خدمة تشغيل الكهرباء/المياه",
	},
	move_out_date: {
		en: "Move-Out Date",
		ar: "تاريخ تفعيل خدمة إيقاف الكهرباء و المباه",
	},
	move_out_ejari_contract_number: {
		en: "Move-Out Ejari Contract Number",
		ar: "رقم عقد إيجاري لتاريخ وقف خدمة الكهرباء و المياه",
	},
	skip: {
		en: "Skip",
		ar: "تجاهل",
	},
	allowed_co_tenants: {
		en: "The maximum allowed number of co-occupants is {0}",
		ar: "الحد الأقصى لعدد القانطين هو {0}",
	},
	terminate_management_contract: {
		en: "Terminate Management Contract",
		ar: "إنهاء عقد الإدارة",
	},
	create_management_contract: {
		en: "Create Management Contract",
		ar: "إنشاء عقد إدارة",
	},
	renew_management_contract: {
		en: "Renew Management Contract",
		ar: "تجديد عقد الإدارة",
	},
	responsibilities: {
		en: "Responsibilities",
		ar: "المسؤوليات",
	},
	agreement_agencies: {
		en: "Agreement Agency",
		ar: "الشركة (الإدارة / الوساطة) العقارية",
	},
	free_of_charge: {
		en: "Free of Charge",
		ar: "مجاناً",
	},
	fixed_amount: {
		en: "Fixed Amount",
		ar: " المبلغ الثابت ",
	},
	agreement_from: {
		en: "Agreement from",
		ar: " تاريخ بداية العقد",
	},
	agreement_to: {
		en: "Agreement to",
		ar: " تاريخ نهاية العقد",
	},
	agreement_type: {
		en: "Agreement type",
		ar: " نوع العقد ",
	},
	activity_type_mg: {
		en: "Activity type",
		ar: " نوع النشاط",
	},
	percentage_of_rent_amount: {
		en: "Percentage Value (of Rent Amount)",
		ar: " نسبة القيمة",
	},
	payment_count: {
		en: "Payment Count",
		ar: " عدد الدفعات",
	},
	reason: {
		en: "Reason",
		ar: "سبب",
	},
	mc_terminate_submitted: {
		en: "Management Contract termination request submitted successfully.\nTo track your request, please select 'View Management Contract Request' option",
		ar: "تم إرسال طلب إنهاء عقد الإدارة بنجاح. \\ n لتعقب طلبك ، الرجاء تحديد الخيار \"عرض طلب عقد الإدارة",
	},
	mc_create_submitted: {
		en: "Management Contract request submitted successfully.",
		ar: "تم إرسال طلب عقد الإدارة بنجاح.",
	},
	mc_renew_submitted: {
		en: "Management Contract request renewed successfully.",
		ar: "تم تجديد طلب عقد الإدارة بنجاح.",
	},
	management_contract_request: {
		en: "Management Contract Request",
		ar: "طلب عقد الإدارة",
	},
	ejari_contract_service: {
		en: "Ejari Contract Services",
		ar: "خدمات عقد إيجاري",
	},
	ejari_contract_details: {
		en: "Ejari Contract Details",
		ar: "تفاصيل عقد إيجاري",
	},
	create_new_ejari_contract: {
		en: "Create Ejari Contract",
		ar: "قم بإنشاء عقد إيجاري",
	},
	terminate_ejari_contract: {
		en: "Terminate Ejari Contract",
		ar: "إنهاء عقد إيجاري",
	},
	renew_ejari_contract: {
		en: "Renew Ejari Contract",
		ar: "تجديد عقد إيجاري",
	},
	view_mgm_contract_request: {
		en: "View Management Contract Requests",
		ar: "عرض طلبات عقد الإدارة",
	},
	management_contract_requests: {
		en: "Management Contract Requests",
		ar: "طلبات عقد الإدارة",
	},
	view_mgm_contract: {
		en: "View Management Contract",
		ar: "عرض عقد الإدارة",
	},
	business_activity_term: {
		en: "By Clicking on this checkbox you agreed that you have paid Dubai Municipality fees.",
	},
	total_fees_compare_payment_plan: {
		en: "Payment plan amount should be equal to total fee.",
	},
	management_contract_services: {
		en: "Management Contract Services",
		ar: "خدمات عقود الإدارة",
	},
	license_source: {
		en: "License Source",
		ar: "مصدر الرخصة",
	},
	owner: {
		en: "Owner",
		ar: "المالك",
	},
	company: {
		en: "Company",
		ar: "الشركة",
	},
	update: {
		en: "Update",
		ar: "تحديث",
	},
	documents: {
		en: "Documents",
		ar: "المستندات",
	},
	add_document: {
		en: "Add Documents",
		ar: "إضافة  مستند",
	},
	mgm_contract_no: {
		en: "Contract Number",
		ar: "رقم العقد",
	},
};
